import audit from './audit'
export type { AuditEntry } from './audit'

export const init = audit.init
export const addEntry = audit.addEntry

export default audit
